(function () {
  function initReveal(root) {
    if (!root || root.dataset.prdRevealReady === 'true') return;
    root.dataset.prdRevealReady = 'true';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.classList.add('is-revealed');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -7% 0px' }
    );

    observer.observe(root);
  }

  function initAll(scope) {
    var container = scope || document;
    container.querySelectorAll('[data-prd-reveal-root]').forEach(initReveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
